<div class="login">
  <ng-container *ngIf="!isClient">
    <div class="login-wrapper login-wrapper--employee">
      <div class="login-content">
        <div class="login-content__form">
          <ng-container *ngTemplateOutlet="loginForm"></ng-container>
        </div>
      </div>
      <div class="login-image">
        <img src="/assets/svg/rm-logo_login.svg" alt="" />
      </div>
    </div>
    <div class="login-wave">
      <img src="/assets/svg/background-wave.svg" alt="" />
      <div></div>
    </div>
  </ng-container>

  <div
    class="login-wrapper login-wrapper--client"
    data-test="login-wrapper"
    *ngIf="isClient"
  >
    <div class="login-content">
      <div class="login-content__form-container">
        <div class="login-content__form">
          <ng-container *ngTemplateOutlet="loginForm"></ng-container>
        </div>
        <div class="login-content__perceuse">
          <img
            class="login-content__perceuse__main"
            src="/assets/images/perceuse.png"
            alt=""
          />
          <img
            class="login-content__perceuse__shadow"
            src="/assets/images/perceuse_shadow.png"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>

  <ng-template #loginForm>
    <div class="login-content__form__logo">
      <img src="/assets/svg/rm-logo.svg" alt="" />
      <div class="login-content__form__title">
        {{ 'LOGIN.TITLE' | translate }}
      </div>
      <form [formGroup]="form" (submit)="submit()">
        <input
          class="rm-input rm-input--center rm-input--with-errors"
          formControlName="email"
          name="email"
          type="email"
          [placeholder]="'LOGIN.FORM.EMAIL.LABEL' | translate"
          data-test="login-email-input"
        />
        <input
          class="rm-input rm-input--center rm-input--with-errors"
          formControlName="password"
          name="current-password"
          matInput
          type="password"
          [placeholder]="'LOGIN.FORM.PASSWORD.LABEL' | translate"
          data-test="login-password-input"
        />
        <button
          type="submit"
          class="rm-button rm-button--primary rm-button--full-width"
          data-test="login-submit-button"
          [disabled]="submitting"
        >
          {{ 'LOGIN.FORM.SUBMIT' | translate }}
        </button>
      </form>
      <a
        class="login-content__forgot-password"
        [routerLink]="['/forgotten-password']"
        queryParamsHandling="merge"
        data-test="login-forgotten-password"
      >
        {{ 'LOGIN.FORGOT_PASSWORD' | translate }}</a
      >
    </div>
  </ng-template>
</div>
